import { render, staticRenderFns } from "./DividedTask.vue?vue&type=template&id=0cdef6c2&scoped=true&"
import script from "./DividedTask.vue?vue&type=script&lang=js&"
export * from "./DividedTask.vue?vue&type=script&lang=js&"
import style0 from "./DividedTask.vue?vue&type=style&index=0&id=0cdef6c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdef6c2",
  null
  
)

export default component.exports